import { Employee } from '@/types/template';

import { backendRequest } from './http-client';

/**
 * Lists employees from the backend API for the current tenant.
 * When `siteIds` is provided and non-empty, filters to employees belonging to those sites.
 *
 * @throws Error if the API call fails
 */
export async function listEmployees(siteIds?: string[]): Promise<Employee[]> {
  const query = siteIds && siteIds.length > 0 ? `?siteIds=${siteIds.join(',')}` : '';
  return backendRequest<Employee[]>(`/v1/employees${query}`, 'Failed to list employees');
}
